<template>
    <svg class="filled" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 283.46 283.46" xml:space="preserve">
<path d="M269.39,77.18c-3.06-11.54-12.09-20.63-23.56-23.71c-20.78-5.6-104.1-5.6-104.1-5.6s-83.32,0-104.1,5.6
	c-11.46,3.08-20.49,12.17-23.56,23.71C8.5,98.1,8.5,141.73,8.5,141.73s0,43.64,5.57,64.55c3.06,11.54,12.09,20.63,23.56,23.71
	c20.78,5.6,104.1,5.6,104.1,5.6s83.32,0,104.1-5.6c11.46-3.08,20.49-12.17,23.56-23.71c5.57-20.91,5.57-64.55,5.57-64.55
	S274.96,98.1,269.39,77.18z M114.48,181.35v-79.24l69.64,39.62L114.48,181.35z"/>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
